import React from "react";
import PolicyLayout, { Section, PolicyList } from "../../components/storefront/PolicyLayout";

export default function ShippingPolicy() {
  return (
    <PolicyLayout
      testid="shipping-policy-page"
      heading="Shipping Policy"
      title="Shipping Policy | Lecis Auto Glass"
      description="How Lecis Auto Glass ships side mirrors, windshields and backglass nationwide — processing times, carriers, freight handling, tracking and shipping damage procedures."
      canonicalPath="/shipping-policy"
      updated="June 2026"
    >
      <Section>
        <p>
          Lecis Auto Glass ships premium side mirrors, windshields and backglass nationwide across the
          contiguous United States from Fair Oaks, California. This policy explains how and when your
          order is processed, shipped and delivered.
        </p>
      </Section>

      <Section title="Order Processing Time">
        <p>
          In-stock orders are typically processed within <strong className="text-zinc-100">1–3 business days</strong>{" "}
          (Monday–Friday, excluding holidays). Orders placed on weekends or holidays begin processing the
          next business day. During periods of high demand or for made-to-order items, processing may take
          slightly longer — we will notify you by email if there is a delay.
        </p>
      </Section>

      <Section title="Shipping Methods & Delivery Times">
        <PolicyList
          items={[
            "Standard ground shipping via reputable carriers (USPS, UPS, FedEx) for most side mirrors and smaller parts.",
            "Estimated ground transit time is typically 2–7 business days depending on your destination.",
            "Expedited options may be available at checkout for eligible items.",
            "Delivery estimates begin once the order has shipped, not at the time of purchase.",
          ]}
        />
      </Section>

      <Section title="Freight Shipping (Oversized Items)">
        <p>
          Windshields, backglass and other large or fragile items are classified as oversized and ship via
          <strong className="text-zinc-100"> freight (LTL) carriers</strong> to protect the glass in transit.
          Freight shipments:
        </p>
        <PolicyList
          items={[
            "May require a signature and, in some cases, a scheduled delivery appointment.",
            "Are delivered curbside; the carrier is not responsible for in-home placement or installation.",
            "May take additional transit time compared to standard ground service.",
            "Should be inspected carefully at the time of delivery (see Shipping Damage below).",
          ]}
        />
      </Section>

      <Section title="Shipping Restrictions">
        <PolicyList
          items={[
            "We currently ship within the contiguous United States. Shipping to Alaska, Hawaii, U.S. territories, P.O. boxes, or international destinations may be limited or unavailable.",
            "Certain oversized items may not be eligible for expedited service.",
            "If we are unable to ship to your address, we will contact you and issue a full refund.",
          ]}
        />
      </Section>

      <Section title="Order Tracking">
        <p>
          Once your order ships, we email a confirmation that includes tracking information (when available)
          so you can follow your shipment to delivery. If you have not received tracking details within a
          reasonable time after your order confirmation, contact us at support@lecisautoglass.com.
        </p>
      </Section>

      <Section title="Shipping Damage Procedure">
        <p>
          Glass products are fragile. Please inspect every shipment immediately upon delivery:
        </p>
        <PolicyList
          items={[
            "For freight deliveries, note any visible damage on the carrier's delivery receipt before signing, and photograph the packaging and product.",
            "Do not discard the original packaging until you have confirmed the item is undamaged.",
            "Report shipping damage to support@lecisautoglass.com within 48 hours of delivery, including your order number and clear photos of the damage and packaging.",
            "We will work with you to arrange a replacement or refund for verified shipping damage at no additional cost to you.",
          ]}
        />
      </Section>
    </PolicyLayout>
  );
}
